import apolloClient from "../apolloClient";
import { GET_ORDERS, CANCEL_ORDER } from "./graphql";

class OrderService {
	async list() {
		const { data } = await apolloClient.query({
			query: GET_ORDERS,
		});
		return data.myOrders.nodes;
	}

	async cancel({ id, reason }) {
		await apolloClient.mutate({
			mutation: CANCEL_ORDER,
			variables: {
				id,
				reason,
			},
		});
	}
}

export default new OrderService();
